import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

/** 后台模板类型 */
export type AdminTemplateType = "VIDEO" | "IMAGE_TEXT" | "ARTICLE";

/** 原始接口单条 */
export interface AdminTemplateListItemResponse {
  template_name_zh_cn: string;
  template_name_zh_hk: string;
  template_name_en_us: string;
  languages: string[];
  description: string;
  used_count: number;
  template_type: AdminTemplateType;
  cover_url: string;
  status: string;
  template_id: string;
  template_name: string;
  template_resource: number;
  createdAt: string;
  updatedAt: string;
  id: string;
}

/** 原始接口响应 */
export interface AdminTemplateListResponse {
  list: AdminTemplateListItemResponse[];
  count: number;
}

export interface AdminTemplateListFilterInput {
  templateId?: string;
  templateType?: AdminTemplateType;
  agentId?: string;
}

/** 请求参数（camelCase，与业务层一致, template_type 由接口写死为 ARTICLE） */
export interface AdminArticleTemplateListRequest {
  filter?: AdminTemplateListFilterInput;
  page: number;
  pageSize: number;
}

export class AdminTemplateListItemData {
  @Required("id cannot be empty")
  @IsString("id must be a string")
  id: string;

  @Required("templateId cannot be empty")
  @IsString("templateId must be a string")
  templateId: string;

  @Required("templateName cannot be empty")
  @IsString("templateName must be a string")
  templateName: string;

  @Required("templateType cannot be empty")
  @IsString("templateType must be a string")
  templateType: string;

  @Required("templateResource cannot be empty")
  @IsNumber("templateResource must be a number")
  templateResource: number;

  @Required("coverUrl cannot be empty")
  @IsString("coverUrl must be a string")
  coverUrl: string;

  @IsArray("languages must be an array")
  languages: string[];

  @IsString("status must be a string")
  status: string;
}

export class AdminArticleTemplateListData {
  @IsArray("list must be an array")
  @ValidateNested(AdminTemplateListItemData, "list item validation failed")
  list: AdminTemplateListItemData[];

  @Required("count cannot be empty")
  @IsNumber("count must be a number")
  count: number;
}

const transformAndValidate = (
  response: AdminTemplateListResponse
): AdminArticleTemplateListData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AdminArticleTemplateListData);
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : String(error);
    console.error("Admin template list validation failed:", message);
    throw error;
  }
};

/** 后台文章模板列表 */
export const adminArticleTemplateList = async ({
  page,
  pageSize,
  filter,
}: AdminArticleTemplateListRequest): Promise<AdminArticleTemplateListData> => {
  const response = await api.post<AdminTemplateListResponse>("/template/list", {
    filter: {
      template_type: 'ARTICLE',
      template_id: filter?.templateId,
      agent_id: filter?.agentId,
    },
    page,
    page_size: pageSize,
  });
  return transformAndValidate(response.data);
};
